import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';

const useAssignmentsAssigneeModels = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const setStore = useGradesTableStore(state => state.setStore);

  const query = useQuery(['AssignmentsAssigneeModel', classroom.id], () => {
    const path = Routes.plato_api_assignments_assignee_models_path({
      for_classroom: classroom.id,
    });

    return axios
      .get(path)
      .then(res => res.data.data);
  });

  useEffect(() => {
    if (query.isFetching || !query.data) return;

    setStore({ assignmentsAssigneeModels: query.data });
  }, [query.data]);

  return query;
};

export default useAssignmentsAssigneeModels;
